<div class="so-filter-bar" #filtersContainer>
    <div class="so-filter-bar__left">
        <div class="so-filter-bar__icon">
            <mat-icon>filter_list</mat-icon>
        </div>

        <div class="so-filter-bar__pills">
            <ng-container *ngTemplateOutlet="filtersTemplate; context: {
                $implicit: this,
                isFilterVisible: isFilterVisible.bind(this)
            }"></ng-container>
        </div>

        @if (hasOverflowFilters) {
            <div class="so-filter-bar__more-wrapper">
                <button class="so-filter-bar__more-btn" (click)="toggleMoreFilters()">
                    <span>Ver más</span>
                    <span class="so-filter-bar__more-count">{{ overflowFilters.length }}</span>
                    <svg class="so-filter-bar__more-chevron" [class.so-filter-bar__more-chevron--open]="isMoreFiltersOpen" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>

                @if (isMoreFiltersOpen) {
                    <div class="so-filter-bar__more-backdrop" (click)="closeMoreFilters()"></div>
                    <div class="so-filter-bar__more-dropdown">
                        @for (filter of filters; track filter.id) {
                            @if (isFilterInOverflow(filter.id)) {
                                <button class="so-filter-bar__more-item" (click)="openFilterFromDropdown(filter.id)">
                                    <span>{{ filter.label }}</span>
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            }
                        }
                    </div>
                }
            </div>
        }
    </div>

    @if (showClearButton) {
        <so-button-gradient-ui
            [text]="clearButtonText"
            [icon]="'mdi-refresh'"
            [variant]="'outline'"
            [color]="'so-gray-thick'"
            [height]="36"
            (clicked)="onClearFilters()"
        ></so-button-gradient-ui>
    }
</div>
